import AccountingDocumentList from './List'
import AccoutingDocumentEdit from './Edit'
import AccountingDocumentCreate from './Create'

export default {
  list: AccountingDocumentList,
  edit: AccoutingDocumentEdit,
  create: AccountingDocumentCreate
}
